import importScanStore from '@modules/importScan/store/importScanStore';

const useImportScanStore = () => {
  const lowerJawFile = importScanStore((state) => state.lowerJawFile);
  const setLowerJawFile = importScanStore((state) => state.setLowerJawFile);
  const upperJawFile = importScanStore((state) => state.upperJawFile);
  const setUpperJawFile = importScanStore((state) => state.setUpperJawFile);

  const upperJawMesh = importScanStore((state) => state.upperJawMesh);
  const setUpperJawMesh = importScanStore((state) => state.setUpperJawMesh);
  const lowerJawMesh = importScanStore((state) => state.lowerJawMesh);
  const setLowerJawMesh = importScanStore((state) => state.setLowerJawMesh);

  const importPhase = importScanStore((state) => state.importPhase);
  const setImportPhase = importScanStore((state) => state.setImportPhase);
  const reset = importScanStore((state) => state.reset);

  return {
    lowerJawFile,
    setLowerJawFile,
    upperJawFile,
    setUpperJawFile,
    upperJawMesh,
    setUpperJawMesh,
    lowerJawMesh,
    setLowerJawMesh,
    importPhase,
    setImportPhase,
    reset,
  };
};

export default useImportScanStore;
